import React from 'react'
import { Heading } from '../shared/typography'

const Section = ({
  id,
  name,
  collection,
  children,
  isSub = false,
  ...restProps
}) => {
  if (collection && collection.length === 0) {
    return null
  } else {
    return (
      <section {...restProps}>
        {isSub ? (
          <Heading>{name}</Heading>
        ) : (
          <Heading anchored color="primary" id={id} size={1}>
            {name}
          </Heading>
        )}
        {children}
      </section>
    )
  }
}

export default Section
